<template>

    <section>
        <div class="inner row3_1 flex mobileFlexCol alignC">   
            <article class="wd100">
                <div class="aRow3 trendSection1">
                    <h1>센터 사업안내</h1>
                    <div class="tab-container">  
                        <div id="tabs">
                            <div class="flex after-dotted" style="margin: 0 auto 0; justify-content: center;">
                                <button class="tab-button" v-for="(tab, index) in tabs" v-bind:class="{active: currentTab === index}" v-on:click="currentTab =index" v-bind:key="tab">
                                    {{ tab }}
                                </button>
                            </div>
                            <div class="tab-content">
                                <div v-show="currentTab==0">
                                    <div class="middle-title">
                                        사용성 평가
                                    </div>
                                    <figure>
                                        <img src="../../assets/images/cmmnBG/center-intro-structure1-1.png" alt="center-info-structure">
                                    </figure>
                                    <button class="download-btn">신청양식 다운로드</button>
                                </div>

                                <div v-show="currentTab==1">
                                    <div class="middle-title">
                                        가이드라인 개발
                                    </div>
                                    <figure>
                                        <img src="../../assets/images/cmmnBG/center-intro-structure2-1.png" alt="center-info-structure2">
                                    </figure>
                                </div>

                                <div v-show="currentTab==2">
                                    <div class="middle-title">
                                        실증
                                    </div>
                                    <figure>
                                        <img src="../../assets/images/cmmnBG/center-intro-structure3-1.png" alt="center-info-structure3">
                                    </figure>
                                </div>

                                <div v-show="currentTab==3">
                                    <div class="middle-title">
                                        체험 홍보관
                                    </div>
                                    <figure>
                                        <img src="../../assets/images/cmmnBG/center-intro-structure4-1.png" alt="center-info-structure4">
                                    </figure>
                                </div>

                                <div v-show="currentTab==4">
                                    <div class="middle-title">
                                        기업지원
                                    </div>
                                    <figure>
                                        <img src="../../assets/images/cmmnBG/center-intro-structure5-1.png" alt="center-info-structure5">
                                    </figure>

                                </div>

                            </div>

                        </div>
                    </div>      
                </div> 
            </article>

        </div>       
    </section> 
    

</template>

<script>

export default {
    name: 'centerIntro',
    components: {
    },
    data() {
        return {
            currentTab:0,
            tabs:['사용성평가', '가이드라인 개발', '실증' , '체험 홍보관', '기업 지원']
        }
    },
}

</script>

<style scoped>
    
    section>.inner {
        width : 160rem;
    }
    .center-brief {padding-left: 11.5rem;}
    .center-brief p {
        font-size: 3rem;
        font-weight: 500;
    }
    .middle-title {
        color:#26336A;
        font-size: 48px;
        font-weight: 700;
        line-height: 72px;
        letter-spacing: -0.015em;
        text-align: center;
        position: relative;
        margin-top:10rem;
        margin-bottom: 4.7rem;
    }
    .middle-title::before {
        content: '';
        width: 120px;
        height: 3px;
        border-top: 4px solid #26336A;
        position: absolute;
        top: -20px;
        left: 46%;
    }

    .tab-button {
        width: 164px;
        height: 143px;
        background: none;
        border: 12px solid #CCC7B9;
        font-size : 2rem;
        font-weight: 500;
        line-height: 3rem;
        color:#CCC7B9;
        cursor: pointer;
        margin: 2rem 4rem 9.5rem;
        word-break: keep-all;
        border-radius: 80px 80px 80px 80px / 70px 70px 70px 70px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 5;
        background-color: #ffffff;
    }
    .after-dotted {
        position: relative;
    }

    .after-dotted::before {
        position: absolute;
        top:86px;
        left:15%;
        width: 110rem;
        content: '';
        border-top: 5px dotted #CCC7B9;
        z-index: 1;
        margin: 0 auto 0;
    }
    

    .tab-button.active {
        color:#ffffff;
        border: 12px solid #26336A;
        background: #26336ACC;
        font-size: 25px;
        font-weight: 700;
        line-height: 25px;
        letter-spacing: 0em;
        text-align: center;
    }

    .download-btn {
        border: none;
        color:#ffffff;
        font-size: 25px;
        font-weight: 500;
        line-height: 25px;
        letter-spacing: -0.05em;
        text-align: center;
        height: 67px;
        background: #651F1D;
        margin: 12.4rem 0 10rem;
        padding: 0 2rem;
        border-radius: 4px;
        cursor: pointer;
    }

    @media screen and (max-width: 560px) {
        .matchPlaform h3 {
            margin: 0;
        }
        .matchPlaform div p {
            margin: 0 0 20px 0;
        }
    }
    @media screen and (max-width: 460px) {
        img {width: 100%; height: auto;}
        .middle-title::before {left:34%;}
        .tab-button {border:none; color: #26336A; width: auto; height: auto; padding: 1rem; font-size: 2rem;}
        .after-dotted {flex-wrap: wrap;}
        .after-dotted::before {display: none;}
        .tab-button.active {border:none; font-size: 2rem;}
    }
</style>

